import { connect } from 'react-redux'
import IntegracionPantallas from '../IntegracionPantallas.jsx';

//Importación de actions.
import
{
    cargaInicialPantalla,
    mostrarOcultarModal
} from '../../actions/Actions.js';

const mapStateToProps = (state) => {
  return {
      data: {
        ...state.integracionPantallas.data,
        ruta: JSON.parse(localStorage.portico).menuProductos.menuUsuario.find(producto => producto.codigo == "TARJETAS")
                                             .categorias.find(categoria => categoria.codigo == "Delivery")
                                             .programas.find(programa => programa.codigo == "INVPLASTICOS").ruta,
        login: JSON.parse(localStorage.portico).sesion.executionContext.login
      }
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    cargaInicialPantalla: (state, currentScope) => {
        dispatch(cargaInicialPantalla(state, currentScope));
    },
    mostrarOcultarModal: () => {
      dispatch(mostrarOcultarModal());
    }
  }
}

//Connect entre el componente y las props y actions.
const InventarioPlasticosContainer = connect(mapStateToProps, mapDispatchToProps)(IntegracionPantallas);

export default InventarioPlasticosContainer;